<template>
  <sky-suffix v-bind="$attrs" @search-click="search">
    <el-select
      :value="selected"
      @change="handleChange"
      v-model="selected"
      v-bind="$attrs"
      placeholder="请输入关键词"
    >
      <el-option
        v-for="item in options"
        :key="item[props.value]"
        :label="item[props.label]"
        :value="item[props.value]">
        <div :is="option.tagName" :data="item" :selected="value"> </div>
      </el-option>
    </el-select>
    <slot name="toolTips" slot="toolTips"></slot>
  </sky-suffix>
</template>
<script>
  import SkySuffix from '../formComponents/SkySuffix.vue'
  export default {
    name: 'sky-select',
    componentName: 'sky-select',
    components: {
      SkySuffix
    },
    props: {
      value: {
        default: null
      },
      options: {
        default: function() {
          return []
        }
      },
      props: {
        default() {
          return {
            label: 'label',
            value: 'value'
          }
        }
      }
    },
    created() {
    },
    data () {
      return {
        selected: this.value
      }
    },
    methods: {
      search (e) {
        this.$emit('search-click', e)
      },
      handleChange(e) {
        this.$emit('input', e)
      }
    }
  }
</script>
